import initialActivitiesData from './data/initialTrackedRoutesData'
import initialActivityTypesData from './data/initialActivityTypesData'
import initialNotesData from './data/initialNotesData'
import initialSettingsData from './data/initialSettingsData'

/*******************************
 * Add preset to selected store
 *******************************/

const addStorePresets = (db, store) => {
  if (db.objectStoreNames.contains(store)) {
    return new Promise((resolve, reject) => {
      let addOperationStatus = false
      let data = null
      let errorMsg = ''
      const newDatumId = null

      // 1. Create a transaction
      // 2. Wait for the database transaction to complete
      //    (A transaction has an oncomplete event, but NOT an onsuccess! (==> see request))
      const tx = db.transaction([store], 'readwrite')

      tx.oncomplete = result => {
        if (addOperationStatus) {
          resolve(true)
        }
        else {
          resolve(errorMsg)
        }
      }

      tx.onerror = error => {
        reject(error)
      }

      switch (store) {
        case 'activityTypes':
          data = initialActivityTypesData
          break

        case 'notes':
          data = initialNotesData
          break

        default:
          data = ''
      }

      data.forEach(datum => {
        // Add the data to the object store (or put)
        // A request returns an onsuccess handler
        const addRequest = tx.objectStore(store).add(datum)

        addRequest.onsuccess = e => {
          addOperationStatus = true
        }

        addRequest.onerror = addError => {
          errorMsg += 'Error with datum "' + datum.title + '"\nCode: ' + addError.srcElement.error.code + '\n' + addError.srcElement.error.message + '\n\n\n'
        }
      })
    })
  }
  else {
    console.error(`The store ${store} does not exist.`)
  }
}

export default addStorePresets
